module.exports = __webpack_public_path__ + "img/tou3.d157d143.jpg";